import { FC, useCallback, useState } from 'react';

import IconComponent from '../IconComponent';
import ChevronIcon from '../IconsSvg/ChevronIcon';

import { getRequestedLanguages } from '../../locale/languages';
import { ICONS } from '../../utils/enum/Icons';
import { ClothingProductAttribute } from '../../utils/models/product';

interface Props {
    code: string;
    tableData: ClothingProductAttribute[];
    selectedColor: string;
}

const TableDataComponent: FC<Props> = ({ code, tableData, selectedColor }) => {
    const language = getRequestedLanguages(window.berardi_accountUserData.language);
    const commonTranslations = document.querySelector('#translationsObject')
        ? JSON.parse(document.querySelector('#translationsObject')!.innerHTML)
        : null;
    const [showAllRows, setShowAllRows] = useState(false);

    const handleShowRows = useCallback(() => {
        setShowAllRows(!showAllRows);
    }, [showAllRows]);

    return (
        <div className="br-specifications__container">
            <table className={`br-specifications__table ${!showAllRows ? '-hiderow' : ''}`}>
                <tr className="br-specifications__item">
                    <td className="label">{language.product.table_data.code}</td>
                    <td className="value">{code}</td>
                </tr>
                {selectedColor ? (
                    <tr className="br-specifications__item">
                        <td className="label">{language.product.table_data.color}</td>
                        <td className="value">{selectedColor}</td>
                    </tr>
                ) : null}
                {tableData.map((data) => {
                    return (
                        <tr className="br-specifications__item">
                            <td className="label">
                                {data.code == 'brand' ? language.product.table_data.brand : data.label}
                            </td>
                            <td className="value">{data.value}</td>
                        </tr>
                    );
                })}
            </table>
            {tableData.length > 2 ? (
                <button
                    onClick={handleShowRows}
                    className={`br-specifications__button ${showAllRows ? 'open' : 'close'}`}
                >
                    <p>
                        {showAllRows ? (
                            <span className="open">{commonTranslations.hide_specification ?? ''}</span>
                        ) : (
                            <span className="close">{commonTranslations.show_more_specification ?? ''}</span>
                        )}
                    </p>
                    <ChevronIcon />
                </button>
            ) : null}
        </div>
    );
};

export default TableDataComponent;
